module.exports = __webpack_public_path__ + "img/banner-01.403b851c.jpg";